import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useAlert } from "../context/AlertProvider";
import {
  changePassword,
  getAccountInfo,
  updateAccountInfo,
} from "../actionCreator/commonActionCreator";
import Layout from "../layout/Layout";
import { getUserInfo } from "../utils/utils";
import { getToken } from "../utils/auth";

const ChangePassword = () => {
  const user = getUserInfo();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    const res = await dispatch(changePassword("", values));
    if (res.status === 200) {
      await dispatch(
        updateAccountInfo(getToken(), {
          passwordChangeNeeded: false,
          id: user?.id,
        })
      );
      await dispatch(getAccountInfo(getToken()));
      showAlert("success", "Password changed successfully!");
      navigate("/dashboard-view");
    } else {
      showAlert("error", "Failed to update credentials. Please try again.");
    }
  };

  return (
    <Layout>
      <div className="auth">
        <div className="social-auth d-flex align-items-center justify-content-center min-vh-100 h-100">
          <div className="login-card" style={{ maxWidth: 555, margin: 20 }}>
            <div className="heading24px  text-color-030334 fw-semibold text-center">
              Congratulations!
            </div>

            <div className="heading16px text-color-414141 text-center mt10">
              You’re just one step away from unlocking the full potential of us!
            </div>
            <div className="py-20 mt10 border-top">
              <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item
                  name="currentPassword"
                  label="Current Password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your current password",
                    },
                  ]}
                >
                  <Input.Password placeholder="Enter current password" />
                </Form.Item>

                <Form.Item
                  name="newPassword"
                  label="New Password"
                  rules={[
                    { required: true, message: "Please enter a new password" },
                    {
                      min: 4,
                      message: "Password must be at least 4 characters",
                    },
                    {
                      max: 100,
                      message: "Password must not exceed 100 characters.",
                    },
                  ]}
                  hasFeedback
                >
                  <Input.Password placeholder="Enter new password" />
                </Form.Item>

                <Form.Item
                  name="confirmPassword"
                  label="Confirm New Password"
                  dependencies={["newPassword"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your new password",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Confirm new password" />
                </Form.Item>

                <Button
                  type="primary"
                  className="theme-btn"
                  htmlType="submit"
                  block
                >
                  Change Password
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ChangePassword;
